module.exports = __webpack_public_path__ + "static/img/11.d141a24b.png";